export default __webpack_public_path__ + "static/media/ISEO CLASS-6 EXAM PATTERN 2025.ca5e38f8.pdf";